import React, { Component } from 'react';
import axios from "axios";
import { Link } from 'react-router-dom';
import { removecart } from '../../utils/byoscart';
import LinesEllipsis from 'react-lines-ellipsis'

import { NotificationContainer } from 'react-notifications';

import Loader from '../utils/Loadersmall';

class Cart extends Component {

    constructor(props) {
        super(props);
        this.state = {
            wishlist:[],
            totalBox:[],
            serviceCheck:false,
        }
    }

    componentDidMount() {
        this.loadCart();
    }

    async loadCart() {
        const params = new URLSearchParams();
        params.append('token', localStorage.getItem('byos_token'));
        try {
          const response = await axios.post('https://shop.mybadge.co.in/api/apiv1/cartList', params);
          let resVal = response.data;
            if(resVal.status==='success'){
                this.setState({wishlist:Array.isArray(resVal.data) ? resVal.data : [], totalBox:resVal.totalAmount || {}, serviceCheck:true});
            }else{
                this.setState({wishlist:[], totalBox:{}, serviceCheck:true});
            }
        } catch (error) {
            this.setState({serviceCheck:true});
            console.error(error);
        }
    }

    localremovewishlist(variation_id){
        removecart(variation_id);
        setTimeout(()=>{
            this.loadCart();
        },200);
    }

    async updateCart(typeVal, variation_id, quantity=0){
        const params = new URLSearchParams();
        params.append('token', localStorage.getItem('byos_token'));
        params.append('type', typeVal);
        params.append('id', variation_id);
        params.append('quantity', quantity);
        try {
          const response = await axios.post('https://shop.mybadge.co.in/api/apiv1/updateCart', params);
          let resVal = response.data;
            if(resVal.status==='success'){
                this.loadCart();
            }
        } catch (error) {
            this.setState({serviceCheck:true});
            console.error(error);
        }
    }

    render() {
        const cartItems = Array.isArray(this.state.wishlist) ? this.state.wishlist : [];
        const totalBox = this.state.totalBox || {};
        const itemCount = cartItems.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
        const totalSavings = cartItems.reduce((sum, item) => {
            const sellingPrice = Number(item.selling_price || 0);
            const offerPrice = Number(item.offer_price || 0);
            const quantity = Number(item.quantity || 0);
            const itemSaving = Math.max(sellingPrice - offerPrice, 0) * quantity;
            return sum + itemSaving;
        }, 0);

        if(this.state.serviceCheck===false) {
            return (<Loader/>);
        }

        return (
            <div className="ps-cart-page ps-cart-page--clean">
                <div className="ps-categogy ps-categogy--separate ps-cart-shell">
                    <div className="container whiteContainer ps-cart-shell__container">
                        <ul className="ps-breadcrumb">
                            <li className="ps-breadcrumb__item"><Link to="/">Home</Link></li>
                            <li className="ps-breadcrumb__item active" aria-current="page">Cart</li>
                        </ul>

                        <div className="ps-cart__header">
                            <div className="ps-cart__headerCopy">
                                <span className="ps-cart__eyebrow">Shopping cart</span>
                                <h1>Your cart is ready for checkout</h1>
                                <p>Review items, adjust quantities, and keep only what you want before paying.</p>
                            </div>
                            <div className="ps-cart__headerStats">
                                <div className="ps-cart__headerStat">
                                    <span>Items</span>
                                    <strong>{itemCount}</strong>
                                </div>
                                <div className="ps-cart__headerStat">
                                    <span>Subtotal</span>
                                    <strong>&#8377; {totalBox.sub_total_cart_value || 0}</strong>
                                </div>
                                <div className="ps-cart__headerStat">
                                    <span>Savings</span>
                                    <strong>&#8377; {totalSavings}</strong>
                                </div>
                            </div>
                        </div>

                        {cartItems.length > 0 ? (
                            <div className="ps-cart__layout">
                                <div className="ps-cart__items">
                                    {cartItems.map((product_details, index) => (
                                        <article className="ps-cart-item" key={`${product_details.cart_id || product_details.variation_id || index}-${index}`}>
                                            <Link
                                                className="ps-cart-item__image"
                                                to={`/details/${Buffer.from(product_details.variation_id).toString('base64')}/${product_details.product_name}`}
                                            >
                                                {product_details.display_image !== '' ? (
                                                    <figure>
                                                        <img src={product_details.display_image} alt={product_details.product_name} />
                                                    </figure>
                                                ) : (
                                                    <figure>
                                                        <img src='/assets/img/byos-no-image.png' alt="No product" />
                                                    </figure>
                                                )}
                                            </Link>

                                            <div className="ps-cart-item__content">
                                                <Link
                                                    className="ps-cart-item__title"
                                                    to={`/details/${Buffer.from(product_details.variation_id).toString('base64')}/${product_details.product_name}`}
                                                >
                                                    <LinesEllipsis
                                                        text={product_details.product_name}
                                                        maxLine='2'
                                                        ellipsis='...'
                                                    />
                                                </Link>

                                                <div className="ps-cart-item__meta">
                                                    <div className="ps-cart-item__priceBlock">
                                                        <span className="ps-cart-item__label">Unit price</span>
                                                        <div className="ps-cart-item__price">&#8377;{product_details.offer_price}</div>
                                                        <div className="ps-cart-item__strike">&#8377;{product_details.selling_price}</div>
                                                    </div>

                                                    <div className="ps-cart-item__qtyBlock">
                                                        <span className="ps-cart-item__label">Quantity</span>
                                                        <div className="ps-cart-qty">
                                                            <button type="button" className="ps-cart-qty__btn" onClick={()=>this.updateCart('D', product_details.cart_id)}>-</button>
                                                            <span className="ps-cart-qty__value">{product_details.quantity}</span>
                                                            <button type="button" className="ps-cart-qty__btn" onClick={()=>this.updateCart('I', product_details.cart_id)}>+</button>
                                                        </div>
                                                    </div>

                                                    <div className="ps-cart-item__totalBlock">
                                                        <span className="ps-cart-item__label">Total</span>
                                                        <div className="ps-cart-item__total">&#8377;{product_details.total_price}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <button
                                                type="button"
                                                className="ps-cart-item__remove"
                                                onClick={()=>this.localremovewishlist(product_details.variation_id)}
                                                aria-label={`Remove ${product_details.product_name}`}
                                            >
                                                <i className="fa fa-trash-o" aria-hidden="true"></i>
                                            </button>
                                        </article>
                                    ))}
                                </div>

                                <aside className="ps-cart-summary">
                                    <div className="ps-cart-summary__card">
                                        <div className="ps-cart-summary__title">Order summary</div>
                                        <div className="ps-cart-summary__row">
                                            <span>Sub total</span>
                                            <strong>&#8377; {totalBox.sub_total_cart_value || 0}</strong>
                                        </div>
                                        <div className="ps-cart-summary__row">
                                            <span>Delivery charges</span>
                                            <strong>&#8377; {totalBox.total_delivery_charges || 0}</strong>
                                        </div>
                                        <div className="ps-cart-summary__row ps-cart-summary__row--total">
                                            <span>Total</span>
                                            <strong>&#8377; {totalBox.total_cart_value || 0}</strong>
                                        </div>
                                        <Link className="ps-cart-summary__checkout ps-btn ps-btn--sm ps-btn--warning" to='/checkout'>Checkout</Link>
                                    </div>
                                </aside>
                            </div>
                        ) : (
                            <div className="ps-cart-empty">
                                <img src="/assets/img/cart-empty-hero.svg" className="ps-cart-empty__image" alt="Empty cart"/>
                                <h3>Your cart is empty</h3>
                                <p>Add products to build your order, then come back here to review them before checkout.</p>
                                <Link to="/" className="ps-btn ps-btn--sm ps-btn--warning byosButton" data-abc="true">Continue Shopping</Link>
                            </div>
                        )}
                    </div>
                </div>

                <NotificationContainer/>
            </div>
        );
    }
}

export default Cart;
